import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { createEndpointSubdiv, deleteEndpointSubdiv } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';

const launchEndpointSubdiv = (params: { koujiBangou: string, operationKey: string }) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    dispatch(actions.launchEndpointSubdiv.started(params));
    const result = await createEndpointSubdiv(params);
    dispatch(actions.launchEndpointSubdiv.done({ params, result }));
  } catch (error) {
    dispatch(actions.launchEndpointSubdiv.failed({ params, error: error.toString() }))
    getLogger().error('endpointOperatioSubdiv/list()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}
const stopEndpointSubdiv = (params: { koujiBangou: string, operationKey: string }) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    dispatch(actions.stopEndpointSubdiv.started(params));
    const result = await deleteEndpointSubdiv(params);
    dispatch(actions.stopEndpointSubdiv.done({ params, result }));
  } catch (error) {
    dispatch(actions.stopEndpointSubdiv.failed({ params, error: error.toString() }))
    getLogger().error('endpointOperatioSubdiv/list()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

export {
  launchEndpointSubdiv,
  stopEndpointSubdiv
};



// WEBPACK FOOTER //
// ./src/redux/modules/endpointOperationSubdiv/operations.ts